import { EnumEndpoints, EnumEndpointsName, EnumMethod } from "@/constants/app/type";
import { callbackSearchFlights } from "./callbacks/callbackSearchFlights";
import { callbackSearchMinFlights } from "./callbacks/callbackSearchMinFlights";
import { callbackFareRules } from "./callbacks/callbackFareRules";
import { callbackGetBaggage } from "./callbacks/callbackGetBaggage";
import { callbackGetSeatMap } from "./callbacks/callbackGetSeatMap";
import { callbackRejectSearchFlight } from "./callbacksReject/callbackRejectSearchFlight";
import { callbackGetGoodFlights } from "./callbacks/callbackGetGoodFlight";
import { getFareRuleService } from "./callbackServices/getFareRuleService";
import { getAirportsService } from "./callbackServices/getAirportsService";
import { callbackGetAirports } from "./callbacks/callbackGetAirports";
import { callbackGetExchangeCurrency } from "./callbacks/callbackGetExchangeCurrency";
import { EnumAPIKey } from "@/constants/app/api";
import { callbackFareRulesFeeConditions } from "./callbacks/callbackFareRulesFeeConditions";
import { callbackCampaignBanners } from "./callbacks/callbackCampaignBanners";

export const flightEnpoints = {
  [EnumEndpointsName.COMMON_ROUTES]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.COMMON_ROUTES,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.COMMON_ROUTE_DETAIL]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.COMMON_ROUTE_DETAIL,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.FLASH_SALE_LIST]: {
    // public-api-migration-guide.md mục 2.2: GET /campaign/list/:productType -> POST /campaign/list (body)
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.FLASH_SALE_LIST,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.CAMPAIGN_LIST]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.CAMPAIGN_LIST,
    api: EnumAPIKey.API_BASE,
    caller: callbackCampaignBanners
  },
  [EnumEndpointsName.CAMPAIGN_DETAIL]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.CAMPAIGN_DETAIL,
    api: EnumAPIKey.API_BASE,
  },
  [EnumEndpointsName.GET_EXCHANGE_CURRENCY]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.GET_EXCHANGE_CURRENCY,
    api: EnumAPIKey.API_BASE,
    caller: callbackGetExchangeCurrency,
  },
  [EnumEndpointsName.GET_FARE_RULES_FEE_CONDITIONS]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.GET_FARE_RULES_FEE_CONDITIONS,
    api: EnumAPIKey.API_BASE,
    caller: callbackFareRulesFeeConditions,
  },
  [EnumEndpointsName.GET_AIRPORTS]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.GET_AIRPORTS,
    api: EnumAPIKey.API_BASE,
    callerService: getAirportsService,
    caller: callbackGetAirports
  },
  [EnumEndpointsName.SEARCH_FLIGHTS]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.SEARCH_FLIGHTS,
    api: EnumAPIKey.API_BASE,
    caller: callbackSearchFlights,
    callerReject: callbackRejectSearchFlight
  },
  [EnumEndpointsName.SEARCH_MIN_FLIGHTS]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.SEARCH_MIN_FLIGHTS,
    api: EnumAPIKey.API_BASE,
    caller: callbackSearchMinFlights
  },
  [EnumEndpointsName.SEARCH_MIN_FLIGHTS_V1]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.SEARCH_MIN_FLIGHTS_V1,
    api: EnumAPIKey.API_BASE,
    caller: callbackSearchMinFlights
  },
  [EnumEndpointsName.GET_FARE_RULES_0]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.GET_FARE_RULES_0,
    api: EnumAPIKey.API_BASE,
    caller: callbackFareRules,
    callerService: getFareRuleService
  },
  [EnumEndpointsName.GET_FARE_RULES_1]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.GET_FARE_RULES_1,
    api: EnumAPIKey.API_BASE,
    caller: callbackFareRules,
    callerService: getFareRuleService
  },
  [EnumEndpointsName.GET_BAGGAGE]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.GET_BAGGAGE,
    api: EnumAPIKey.API_BASE,
    caller: callbackGetBaggage
  },
  [EnumEndpointsName.GET_SEAT_MAP]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.GET_SEAT_MAP,
    api: EnumAPIKey.API_BASE,
    caller: callbackGetSeatMap
  },
  [EnumEndpointsName.GET_GOOD_FLIGHTS]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.GET_GOOD_FLIGHTS,
    api: EnumAPIKey.API_BASE,
    caller: callbackGetGoodFlights
  },
  [EnumEndpointsName.SEO_ROUTES]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.SEO_ROUTES,
    api: EnumAPIKey.API_BASE,
  },
}